export interface NgStaticGridItemModel {
    x: number;
    y: number;
    width: number;
    height: number;
}